import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'
import OutsideClickHandler from 'react-outside-click-handler'

import CustomDate from '../../../../../CustomDate'
import Currency from '../../../../../Currency'

import { getNumberMagnitude, getCSSYearClass } from '../../helpers'

import './style.scss'

export default class ColumnBody extends Component {
    static propTypes = {
        column: PropTypes.object.isRequired,
        compareYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        // data: PropTypes.array,
        handleCompareYearChange: PropTypes.func.isRequired,
        handleSampleYearChange: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        numberMagnitude: PropTypes.number,
        sampleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        setYears: PropTypes.func.isRequired,
        showUnitsAndCurr: PropTypes.bool,
        tableType: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            asCompareYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            asSampleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            dateFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            dateTo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            standard: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sampleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            compareYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            audit: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            consolidation: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            thousand: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            million: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            billion: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            trillion: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            yes: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            no: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            subjects: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            activeYearDropdown: null,
        }
    }

    handleDropdownBtnClick = (year, activeYearDropdown) => {
        if (activeYearDropdown === year) {
            this.setState({ activeYearDropdown: null })
            return null
        }

        this.setState({ activeYearDropdown: year })
        return null
    }

    handleCloseDropdown = () => {
        this.setState({ activeYearDropdown: null })
    }

    handleYearDropdownRowClick = (year, type) => {
        const { id, sampleYear, compareYear, handleCompareYearChange, handleSampleYearChange, setYears, tableType } =
            this.props

        if (type === 'sampleYear') {
            // If the selected year is currently selected as compareYear, swap compareYear and sampleYear
            if (compareYear === year) {
                setYears(id, tableType, sampleYear, compareYear)
            } else {
                handleSampleYearChange(id, tableType, year)
            }
        } else if (type === 'compareYear') {
            // If the selected year is currently selected as sampleYear, swap sampleYear and compareYear
            if (sampleYear === year) {
                setYears(id, tableType, sampleYear, compareYear)
            } else {
                handleCompareYearChange(id, tableType, year)
            }
        }

        // Close dropdown
        this.setState({ activeYearDropdown: null })
        return null
    }

    render() {
        const { column, translates, compareYear, sampleYear, showUnitsAndCurr, numberMagnitude } = this.props
        const { activeYearDropdown } = this.state

        const magnitude = getNumberMagnitude(numberMagnitude)
        const infoCells = ['standard', 'audit', 'consolidation']
        const dateCells = [
            { textSelector: 'dateFrom', selector: 'startDate' },
            { textSelector: 'dateTo', selector: 'endDate' },
        ]

        return (
            <div
                className={'dc-column-header'}
                style={{ justifyContent: showUnitsAndCurr ? 'space-between' : 'flex-start' }}
            >
                <div className={'dc-header-label'}>
                    <span
                        className={classnames(
                            'dc-year-label',
                            getCSSYearClass(_.get(column, 'year'), sampleYear, compareYear)
                        )}
                    >
                        {_.get(column, 'year') === sampleYear ? `${translates.sampleYear}` : ''}
                        {_.get(column, 'year') === compareYear ? `${translates.compareYear}` : ''}
                    </span>
                    <span
                        className={classnames(
                            'dc-year',
                            getCSSYearClass(_.get(column, 'year'), sampleYear, compareYear)
                        )}
                    >
                        {_.get(column, 'year', '')}
                        <OutsideClickHandler
                            disabled={_.get(column, 'year') !== activeYearDropdown}
                            onOutsideClick={() => this.handleCloseDropdown()}
                        >
                            <button
                                onClick={() =>
                                    this.handleDropdownBtnClick(_.get(column, 'year', null), activeYearDropdown)
                                }
                                className={'dropdown-btn'}
                            />
                            <div
                                className={classnames(
                                    'change-year-dropdown',
                                    _.get(column, 'year') === activeYearDropdown && 'active'
                                )}
                            >
                                <div
                                    className={'dropdown-row'}
                                    onClick={() =>
                                        this.handleYearDropdownRowClick(_.get(column, 'year', null), 'compareYear')
                                    }
                                >
                                    <span className={'dropdown-text'}>{translates.asCompareYear}</span>
                                </div>
                                <div
                                    className={'dropdown-row'}
                                    onClick={() =>
                                        this.handleYearDropdownRowClick(_.get(column, 'year', null), 'sampleYear')
                                    }
                                >
                                    <span className={'dropdown-text'}>{translates.asSampleYear}</span>
                                </div>
                            </div>
                        </OutsideClickHandler>
                    </span>
                </div>
                <div className={'dc-info-container'}>
                    {
                        // DATES
                        _.map(
                            dateCells,
                            ({ textSelector, selector }) =>
                                _.get(column, `${selector}.value`) && (
                                    <div key={`${column.year}-${selector}-row`} className={'dc-info-row date'}>
                                        <span>{`${_.get(translates, `${textSelector}`, '')}: `}</span>
                                        <span className={'dc-info-value'}>
                                            <CustomDate
                                                date={_.get(column, `${selector}.value`, null)}
                                                precision={_.get(column, `${selector}.precision`, 'days')}
                                            />
                                        </span>
                                    </div>
                                )
                        )
                    }
                    {
                        // STANDARD, AUDIT, CONSILIDATION
                        _.map(
                            infoCells,
                            (selector) =>
                                _.get(column, `${selector}`) && (
                                    <div key={`${column.year}-${selector}-row`} className={'dc-info-row'}>
                                        <span>{`${_.get(translates, `${selector}`, '')}: `}</span>
                                        <span className={'dc-info-value'}>{_.get(column, `${selector}`, '')}</span>
                                    </div>
                                )
                        )
                    }
                    {
                        // NACE CONTAINERS
                        // Category
                        <div className={'dc-info-row'}>
                            <span className={'dc-info-fullwidth'}>
                                {
                                    _.get(column, 'category') &&
                                        column.category // Ex.: Something (detail)
                                            .split('(') // Split by (
                                            .shift() // Get first element
                                            .replace(/^\w/, (c) => c.toUpperCase()) // First char to uppercase
                                }
                                {_.isNull(_.get(column, 'category')) && (
                                    <div>
                                        <div>{'N/A'}</div>
                                        <div>{'N/A'}</div>
                                        <div>{'N/A'}</div>
                                    </div>
                                )}
                            </span>
                        </div>
                    }
                    {
                        // Category - detail
                        _.get(column, 'category') && (
                            <div key={`${column.year}-category-2-row`} className={'dc-info-row'}>
                                <span className={'dc-info-fullwidth'}>
                                    {
                                        _.get(column, 'category') // Ex.: Something (detail)
                                            .split('(') // Split by (
                                            .pop() // Get last element
                                            .slice(0, -1) // Remove last char
                                            .replace(/^\w/, (c) => c.toUpperCase()) // First char to uppercase
                                    }
                                </span>
                            </div>
                        )
                    }
                    {
                        // Number of subjects
                        _.get(column, 'category') && _.get(column, 'subjects') && (
                            <div key={`${column.year}-subjects-row`} className={'dc-info-row'}>
                                <span className={'dc-info-fullwidth'}>
                                    {`${_.get(translates, 'subjects', '').replace(/^\w/, (c) => c.toUpperCase())}: `}
                                    {_.get(column, 'subjects')}
                                </span>
                            </div>
                        )
                    }
                </div>
                {
                    // Units of the column
                    showUnitsAndCurr && (
                        <span className={'dc-column-units'}>
                            {`(${
                                magnitude && magnitude.translate
                                    ? `${_.get(translates, `${magnitude.translate}`, '')} `
                                    : ''
                            }`}
                            <Currency currency={column?.currency} />
                            {')'}
                        </span>
                    )
                }
            </div>
        )
    }
}
